var currentIndex = 0;
var transitionDuration = '500';

function getItemsToShow(element) {
  if (element.hasClass("twoItems")) {
    twoItemsStyle = window.getComputedStyle(document.querySelector('.twoItems'));
    itemsToShow = parseFloat(twoItemsStyle.getPropertyValue('--reusableCarousel_items_to_show'));
  }
  else if (element.hasClass("threeItems")) {
    threeItemsStyle = window.getComputedStyle(document.querySelector('.threeItems'));
    itemsToShow = parseFloat(threeItemsStyle.getPropertyValue('--reusableCarousel_items_to_show'));
  }
  else if (element.hasClass("fourItems")) {
    fourItemsStyle = window.getComputedStyle(document.querySelector('.fourItems'));
    itemsToShow = parseFloat(fourItemsStyle.getPropertyValue('--reusableCarousel_items_to_show'));
  }
  else if (element.hasClass("fiveItems")) {
    fiveItemsStyle = window.getComputedStyle(document.querySelector('.fiveItems'));
    itemsToShow = parseFloat(fiveItemsStyle.getPropertyValue('--reusableCarousel_items_to_show'));
  }
  else if (element.hasClass("sixItems")) {
    sixItemsStyle = window.getComputedStyle(document.querySelector('.sixItems'));
    itemsToShow = parseFloat(sixItemsStyle.getPropertyValue('--reusableCarousel_items_to_show'));
  }
  else {
    itemStyle = window.getComputedStyle(document.body);
    bp2Style = parseFloat(itemStyle.getPropertyValue('--reusableCarousel_items_to_show_bp2'));
    standardStyle = parseFloat(itemStyle.getPropertyValue('--reusableCarousel_items_to_show'));
    element.parents('#buyingProcessTwo').length ? itemsToShow = bp2Style : itemsToShow = standardStyle;
  }
  return itemsToShow;
}

function showIndex(element, childCount) {
  var itemsToShow = getItemsToShow(element.find(".reusableCarouselItems"));
  var $productIndex = $('<div/>')
    .addClass('productIndexContainer');
  if (itemsToShow > 1) {
    $productIndex.text(`1 - ${itemsToShow} of ${childCount} items`);
  }
  else {
    $productIndex.text(`1 of ${childCount} items`);
  }
  $productIndex.appendTo(element).find('.reusableCarouselContainer');
}

function updateIndex(element, index, childCount) {
  var itemsToShow = getItemsToShow(element.find(".reusableCarouselItems"));
  var $productIndex = $('<div/>')
    .addClass('productIndexContainer');
  if (itemsToShow > 1) {
    $productIndex.text(`${index + 1} - ${itemsToShow + index} of ${childCount} items`);
  }
  else {
    $productIndex.text(`${index + 1} of ${childCount} items`);
  }
  $productIndex.appendTo(element);
}

function addChevrons() {
  var $chevronLeft = $('<i/>')
    .addClass("fa-solid fa-chevron-left disabled")
    .attr("data-parent", "reusable-carousel")
    .prependTo('.reusableCarouselContainer');
  
  var $rightButton = $("<i/>")
    .addClass("fa-solid fa-chevron-right")
    .attr("data-parent", "reusable-carousel")
    .appendTo('.reusableCarouselContainer');
  var thisCarousel = $rightButton.siblings(".reusableCarousel").find('.reusableCarouselItems');
  var childCount = parseInt(thisCarousel.attr('data-child-count'));

  getItemsToShow(thisCarousel) >= childCount ? $rightButton.addClass('disabled') : $rightButton.removeClass('disabled');
  showItems();
}

function showItems() {
  $('.reusableCarouselItems').each(function() {
    var childCount = $(this).attr('data-child-count');
    var $associatedRightButton = $(this).parent('.reusableCarousel').siblings('.fa-chevron-right');
    var $loadingText = $(this).parents(".wrapper").find(".loadingText");
    $loadingText.remove();
    getItemsToShow($(this)) >= childCount ? $associatedRightButton.addClass('disabled') : $associatedRightButton.removeClass('disabled');
      
    if (childCount > getItemsToShow($(this))) {
      showIndex($(this).parents(".reusableCarouselContainer"), childCount);
    }
    
    setTimeout(() => {
      $(this).addClass('visible');
    }, 100);
  })
}

function wrapCarousel() {
  var $reusableCarousel = $('<div/>')
    .addClass('reusableCarousel');
  $('.reusableCarouselItems').wrap($reusableCarousel);
  $('.reusableCarouselItems').attr('data-offset', 0);

  var $reusableCarouselContainer = $('<div/>')
    .addClass('reusableCarouselContainer');
  $('.reusableCarousel').wrap($reusableCarouselContainer);
  addChevrons()
}

$(window).resize(function() {
  //getCSSVariables();
});

$(document).ready(function() {
  setTimeout(() => {
    wrapCarousel();
  }, 1000);
  
  $(document).on('click', 'i[data-parent="reusable-carousel"]', function() {
    var chevron = $(this);
    var associatedChevron = chevron.siblings("i");
    if (!chevron.hasClass("disabled")) {
      
      var thisCarousel = chevron.siblings(".reusableCarousel").find('.reusableCarouselItems');
      var childCount = parseInt(thisCarousel.attr('data-child-count'));
      currentIndex = parseInt(thisCarousel.attr('data-offset'));

      itemsToShow = getItemsToShow(thisCarousel);
      console.log(itemsToShow)
      
      if (chevron.hasClass("fa-chevron-right")) {
        var remainingItems = childCount - (itemsToShow + currentIndex);
        itemsToShow > remainingItems ? currentIndex += remainingItems : currentIndex += itemsToShow;
        if (currentIndex < childCount - itemsToShow) {
          chevron.removeClass('disabled')
        }
        if (remainingItems == 0) {
          currentIndex = 0;
        }
        currentIndex > 0 ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      else {
        itemsToShow > currentIndex ? currentIndex = 0 : currentIndex -= itemsToShow;
        currentIndex > 0 ? chevron.removeClass('disabled') : chevron.addClass('disabled');
        currentIndex < childCount - itemsToShow ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      chevron.siblings(".productIndexContainer").remove();
      updateIndex(chevron.parents(".reusableCarouselContainer"), currentIndex, childCount);
      thisCarousel.attr('data-offset', currentIndex);
      var offset = ((100/itemsToShow)*currentIndex)*-1;
      thisCarousel.css({"transform": `translateX(${offset}%)`, 'transition-duration': `${transitionDuration}ms`});
    }
  });
});    